// test2288
(2288 && 0);
